export const SET_USER_PARAMETERS = "SET_USER_PARAMETERS";
export const SET_USER_MOBILE_TOKEN = "SET_USER_MOBILE_TOKEN";